import React from 'react';
import ReactDOM from 'react-dom';
import { toDateString, now } from 'common/datetime';
import Wahanda from 'common/wahanda';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

interface OpenInstantSaleCheckoutOptions {
  isLiteCheckoutEnabled?: boolean;
  isStandaloneTerminal?: boolean;
  customerId?: number;
}

export const openInstantSaleCheckout = ({
  isLiteCheckoutEnabled = false,
  isStandaloneTerminal = false,
  customerId,
}: OpenInstantSaleCheckoutOptions = {}) => {
  const node = getOrAppendChild({
    id: 'calendar-instant-sale-checkout',
    parentNode: document.body,
  });
  const onClose = () => ReactDOM.unmountComponentAtNode(node);

  ReactDOM.render(
    <Reconnect
      name="Checkout"
      props={{
        customerId,
        date: toDateString(now()),
        isCheckoutV2Enabled: Wahanda.Features.isEnabled('TEF-2139-new-checkout-flow-v2'),
        isInstantSale: true,
        isLiteCheckoutEnabled,
        isStandaloneTerminal,
        onClose,
      }}
    />,
    node,
  );
};
